import { render, staticRenderFns } from "./EmailAccordion.vue?vue&type=template&id=4d2cc594&"
import script from "./EmailAccordion.vue?vue&type=script&lang=js&"
export * from "./EmailAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports